import React from 'react';
import Style from './formPreview.module.css';
import { InputLabel, InputSublabel, Date } from '@weezevent/nacre';
import moment from 'moment/moment';

export default function FormBirthdate({ field, label, value = null, id = null, onChangeForm = () => {}, locale = 'en-GB' }) {
    const currentYear = new Date().getFullYear();
    const onChange = React.useCallback(
        v => {
            if (id) {
                onChangeForm(id, v);
                return;
            }
        },
        [id, onChangeForm]
    );

    //To ensure the backward compatibility of date of birth fields with Menhir,
    //in input we receive a 'DD/MM/YYYY' format and in output 'DD/MM/YYYY'.
    //When we create new date of birth fields in Menhir ,
    //we can process everything in isoString.
    const _value = React.useMemo(() => {
        if (!value) {
            return '';
        }

        let momentObj = moment(value, 'DD/MM/YYYY');
        if (!momentObj.isValid()) {
            return '';
        }

        return momentObj.format('YYYY-MM-DD');
    }, [value]);

    return (
        <div className={Style['field']}>
            <InputLabel label={label} required={field.required} />
            {field.form_field.description && <InputSublabel label={field.form_field.description} />}
            <Date.Input
                value={_value}
                locale={locale === 'en-GB' ? 'en' : locale}
                onChange={date => {
                    onChange(date);
                }}
                minYear={currentYear - 120}
                maxYear={currentYear}
                returnFormat={'DD/MM/YYYY'}
            />
        </div>
    );
}
